import { FormFeedback } from '@backend/lib-design-system';
import type { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

import { useSearchFormContext } from '~/contexts/SearchFormContext/SearchFormContext';
import { useTranslation } from '~/hooks';
import { getMediaQuery } from '~/utils/responsive/media';

const StyledHeaderFormFieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledHeaderFormFieldLabel = styled.label`
  display: block;
  color: ${({ theme }) => theme.palette.white};
  font-family: ${({ theme }) => theme.typography.fontFamily.regular};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  line-height: ${({ theme }) => theme.typography.lineHeight.m};

  ${getMediaQuery('mobile')} {
    text-align: center;
  }

  ${getMediaQuery('tablet', 'desktop', 'laptop')} {
    padding-left: 1.5rem;
  }
`;

const StyledHeaderFormFieldFeedback = styled(FormFeedback)`
  bottom: 0;
  margin-left: 28px;
  position: absolute;
  transform: translateY(calc(100% + 6px));
  i,
  span {
    color: ${({ theme }) => theme.palette.red200};
  }
`;

interface HeaderFieldProps {
  type: 'job' | 'address';
}

export const HeaderFormField = ({ type, children }: PropsWithChildren<HeaderFieldProps>) => {
  const t = useTranslation();
  const { form, submitted } = useSearchFormContext();

  const error = form[type]?.error;

  return (
    <StyledHeaderFormFieldWrapper>
      <StyledHeaderFormFieldLabel>{t(`form_labels.${type}`)}</StyledHeaderFormFieldLabel>
      {children}
      {submitted && error && (
        <StyledHeaderFormFieldFeedback intent="danger">{t(`form_errors.${type}`)}</StyledHeaderFormFieldFeedback>
      )}
    </StyledHeaderFormFieldWrapper>
  );
};
